import { useTranslation } from 'react-i18next';
import { PageHeader } from 'web-components-ts';
import UserInviteForm from '../../components/forms/UserManagement/UserInviteForm';
import { PageHeaderContainer } from './elements';
import ConnectedUserManagementContent from './ConnectedUserManagementContent';

const UserManagement = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeaderContainer>
        <PageHeader fontSize={24} title={t('user_management.title')} tooltipText={t('user_management.title_tooltip')} />
        <UserInviteForm />
      </PageHeaderContainer>

      <ConnectedUserManagementContent />
    </>
  );
};
export default UserManagement;
